import { h, ComponentChildren, ComponentType } from "preact";

import classname from "../../../../foundation/utils/classname";
import IconCheck from "../../Icons/IconCheck";
import IconProps from "../../Icons/IconProps";
import withMenuItem, { WithMenuItemProps } from "../withMenuItem";

import "../style.css";

interface Props extends WithMenuItemProps {
    class?: string;
    href: string;
    inApp?: boolean;
    icon?: ComponentType<IconProps>;
    children?: ComponentChildren;
    checked?: boolean;
    onClick?: (ev: Event, value?: string, checked?: boolean) => void;
}

export default function MenuLink({
    class: cssClass,
    href,
    inApp,
    icon: Icon,
    children,
    checked,
    content,
    highlighted,
    menuItemRef,
    onClick,
    onMenuItemMouseEnter,
    onMenuItemClick,
    onMenuItemMouseMove
}: Props) {
    function handleClick(event: Event) {
        onClick?.(event);
        onMenuItemClick?.(event);
    }

    // if children is jsx, its expected to handle its own overflow / title expectations
    const title = typeof children === "string" ? children : content;

    return (
        <a
            ref={menuItemRef}
            class={classname("menuLink body-1", cssClass, { highlighted, hasRightContent: checked })}
            href={href}
            target={inApp ? undefined : "_blank"}
            data-link-type={inApp ? "inApp" : undefined}
            rel="noopener"
            title={title}
            onMouseEnter={onMenuItemMouseEnter}
            onClick={handleClick}
            onMouseMove={onMenuItemMouseMove}>
            {Icon && (
                <div class="icon">
                    <Icon/>
                </div>
            )}
            <span class="content ellipsis">{children ?? content}</span>
            {checked && (
                <div class="rightContent">
                    <IconCheck class="tick"/>
                </div>
            )}
        </a>
    );
}

export const MenuLinkAsMenuItem = withMenuItem(MenuLink);
